import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=4715a296&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports